import gql from 'graphql-tag';

import { ContentTemplateFragment } from 'lane-shared/graphql/fragments';

export default gql`
  ${ContentTemplateFragment}

  query contentTemplatesOnUserQuery(
    $userId: UUID!
    $search: ContentTemplateSearch
    $pagination: PaginationInput
  ) {
    contentTemplatesOnUser(
      userId: $userId
      search: $search
      pagination: $pagination
    ) {
      pageInfo {
        start
        total
        perPage
      }
      items {
        _id
        template {
          ...ContentTemplateFragment
        }
      }
    }
  }
`;
